// // projectStepManager.js

export const STEP = {
    // 전단계
    TEMP: '임시저장',
    REGISTER: '프로젝트 등록',

    // 견적
    ESTIMATE_WRITE: '견적서 작성',
    ESTIMATE_RECEIVE: '견적서 수신',
    ESTIMATE_APPROVE: '견적서 승인',

    // 계약
    CONTRACT_WRITE: '계약서 작성',
    CONTRACT_RECEIVE: '계약서 수신',
    CONTRACT_SIGN: '계약서 서명',

    // 진행
    DEPOSIT: '선금 납부',
    DEV1: '1단계 개발',
    DEV1_RECEIVE: '1단계 보고서 수신',
    DEV1_APPROVE: '1단계 보고서 승인',
    MIDDLE: '중도금 납부',

    DEV2: '2단계 개발',
    DEV2_RECEIVE: '2단계 보고서 수신',
    DEV2_APPROVE: '2단계 보고서 승인',

    FINAL_REPORT: '3단계 개발',
    FINAL_REPORT_RECEIVE: '3단계 보고서 수신',
    FINAL_REPORT_APPROVE: '3단계 보고서 승인',
    FINAL_PAY: '잔금 납부',

    // 종료
    DONE: '프로젝트 완료',
}

// 단계 순서
export function getStepOrder(step) {
    var orderMap = {}

    orderMap[STEP.TEMP] = 0
    orderMap[STEP.REGISTER] = 1

    orderMap[STEP.ESTIMATE_WRITE] = 2
    orderMap[STEP.ESTIMATE_RECEIVE] = 3
    orderMap[STEP.ESTIMATE_APPROVE] = 4

    orderMap[STEP.CONTRACT_WRITE] = 5
    orderMap[STEP.CONTRACT_RECEIVE] = 6
    orderMap[STEP.CONTRACT_SIGN] = 7

    orderMap[STEP.DEPOSIT] = 8
    orderMap[STEP.DEV1] = 9
    orderMap[STEP.DEV1_RECEIVE] = 10
    orderMap[STEP.DEV1_APPROVE] = 11
    orderMap[STEP.MIDDLE] = 12

    orderMap[STEP.DEV2] = 13
    orderMap[STEP.DEV2_RECEIVE] = 14
    orderMap[STEP.DEV2_APPROVE] = 15

    orderMap[STEP.FINAL_REPORT] = 16
    orderMap[STEP.FINAL_REPORT_RECEIVE] = 17
    orderMap[STEP.FINAL_REPORT_APPROVE] = 18
    orderMap[STEP.FINAL_PAY] = 19

    orderMap[STEP.DONE] = 20

    if (typeof orderMap[step] === 'number') {
        return orderMap[step]
    }

    return -1
}

// 다음 단계
export function nextStep(step) {
    switch (step) {
        case STEP.TEMP:
            return STEP.REGISTER
        case STEP.REGISTER:
            return STEP.ESTIMATE_WRITE
        case STEP.ESTIMATE_WRITE:
            return STEP.ESTIMATE_RECEIVE
        case STEP.ESTIMATE_RECEIVE:
            return STEP.ESTIMATE_APPROVE
        case STEP.ESTIMATE_APPROVE:
            return STEP.CONTRACT_WRITE
        case STEP.CONTRACT_WRITE:
            return STEP.CONTRACT_RECEIVE
        case STEP.CONTRACT_RECEIVE:
            return STEP.CONTRACT_SIGN
        case STEP.CONTRACT_SIGN:
            return STEP.DEPOSIT

        case STEP.DEPOSIT:
            return STEP.DEV1
        case STEP.DEV1:
            return STEP.DEV1_RECEIVE
        case STEP.DEV1_RECEIVE:
            return STEP.DEV1_APPROVE
        case STEP.DEV1_APPROVE:
            return STEP.MIDDLE

        case STEP.MIDDLE:
            return STEP.DEV2
        case STEP.DEV2:
            return STEP.DEV2_RECEIVE
        case STEP.DEV2_RECEIVE:
            return STEP.DEV2_APPROVE

        case STEP.DEV2_APPROVE:
            return STEP.FINAL_REPORT
        case STEP.FINAL_REPORT:
            return STEP.FINAL_REPORT_RECEIVE
        case STEP.FINAL_REPORT_RECEIVE:
            return STEP.FINAL_REPORT_APPROVE
        case STEP.FINAL_REPORT_APPROVE:
            return STEP.FINAL_PAY

        case STEP.FINAL_PAY:
            return STEP.DONE
        default:
            return step
    }
}

// 이전 단계
export function prevStep(step) {
    switch (step) {
        case STEP.REGISTER:
            return STEP.TEMP

        case STEP.ESTIMATE_WRITE:
            return STEP.REGISTER
        case STEP.ESTIMATE_RECEIVE:
            return STEP.ESTIMATE_WRITE
        case STEP.ESTIMATE_APPROVE:
            return STEP.ESTIMATE_RECEIVE

        case STEP.CONTRACT_WRITE:
            return STEP.ESTIMATE_APPROVE
        case STEP.CONTRACT_RECEIVE:
            return STEP.CONTRACT_WRITE
        case STEP.CONTRACT_SIGN:
            return STEP.CONTRACT_RECEIVE

        case STEP.DEPOSIT:
            return STEP.CONTRACT_SIGN
        case STEP.DEV1:
            return STEP.DEPOSIT
        case STEP.DEV1_RECEIVE:
            return STEP.DEV1
        case STEP.DEV1_APPROVE:
            return STEP.DEV1_RECEIVE
        case STEP.MIDDLE:
            return STEP.DEV1_APPROVE

        case STEP.DEV2:
            return STEP.MIDDLE
        case STEP.DEV2_RECEIVE:
            return STEP.DEV2
        case STEP.DEV2_APPROVE:
            return STEP.DEV2_RECEIVE

        case STEP.FINAL_REPORT:
            return STEP.DEV2_APPROVE
        case STEP.FINAL_REPORT_RECEIVE:
            return STEP.FINAL_REPORT
        case STEP.FINAL_REPORT_APPROVE:
            return STEP.FINAL_REPORT_RECEIVE
        case STEP.FINAL_PAY:
            return STEP.FINAL_REPORT_APPROVE

        case STEP.DONE:
            return STEP.FINAL_PAY

        case STEP.TEMP:
            return STEP.TEMP
        default:
            return step
    }
}

// 관리자 작성 버튼 가능 단계
export function canWriteStep(step) {
    return (
        step === STEP.ESTIMATE_WRITE ||
        step === STEP.CONTRACT_WRITE ||
        step === STEP.DEV1 ||
        step === STEP.DEV2 ||
        step === STEP.FINAL_REPORT
    )
}

// 수요기업 승인 버튼 노출
export function showApproveButton(step, data, user) {
    if (!data || !user) return false

    // 수요기업만
    if (user.uGrade !== 0) return false

    if (step === STEP.ESTIMATE_RECEIVE) {
        return !data.b3f
    }

    if (step === STEP.DEV1_RECEIVE) {
        return !data.r1f
    }

    if (step === STEP.DEV2_RECEIVE) {
        return !data.r2f
    }

    if (step === STEP.FINAL_REPORT_RECEIVE) {
        return !data.r3f
    }

    return false
}

// 관리자 단계 상승 가능 여부
export function canAdminStepUp(step, data) {
    if (step === STEP.TEMP) return true
    if (step === STEP.REGISTER) return true

    if (step === STEP.ESTIMATE_WRITE) return true
    if (step === STEP.ESTIMATE_RECEIVE) return !!(data && data.b3f)
    if (step === STEP.ESTIMATE_APPROVE) return true

    if (step === STEP.CONTRACT_WRITE) {
        return !!(data && (data.c1f || data.writedone))
    }

    if (step === STEP.CONTRACT_RECEIVE) {
        return !!(data && (data.c1f || data.writedone))
    }

    if (step === STEP.CONTRACT_SIGN) {
        return !!(data && data.c2f)
    }

    if (step === STEP.DEPOSIT) {
        return !!(data && data.c2f)
    }

    if (step === STEP.DEV1) {
        return !!(data && data.d2f)
    }

    if (step === STEP.DEV1_RECEIVE) {
        return !!(data && data.develop1)
    }

    if (step === STEP.DEV1_APPROVE) {
        return !!(data && data.r1f)
    }

    if (step === STEP.MIDDLE) {
        return !!(data && data.r1f)
    }

    if (step === STEP.DEV2) {
        return !!(data && data.d4f)
    }

    if (step === STEP.DEV2_RECEIVE) {
        return !!(data && data.develop2)
    }

    if (step === STEP.DEV2_APPROVE) {
        return !!(data && data.r2f)
    }

    if (step === STEP.FINAL_REPORT) {
        return !!(data && data.r2f)
    }

    if (step === STEP.FINAL_REPORT_RECEIVE) {
        return !!(data && data.develop3)
    }

    if (step === STEP.FINAL_REPORT_APPROVE) {
        return !!(data && data.r3f)
    }

    if (step === STEP.FINAL_PAY) {
        return !!(data && data.r3f)
    }

    if (step === STEP.DONE) {
        return !!(data && data.e1)
    }

    return false
}

// 관리자 단계 상승 차단 문구
export function getAdminStepUpBlockMessage(step, data) {
    if (step === STEP.ESTIMATE_RECEIVE && !(data && data.b3f)) {
        return '수요기업의 견적서 승인이 완료되지 않아 다음 단계로 이동할 수 없습니다.'
    }

    if (step === STEP.CONTRACT_WRITE && !(data && (data.c1f || data.writedone))) {
        return '계약서 작성이 완료되지 않아 다음 단계로 이동할 수 없습니다.'
    }

    if (step === STEP.CONTRACT_RECEIVE && !(data && (data.c1f || data.writedone))) {
        return '계약서 작성이 완료되지 않아 계약서 수신 단계로 이동할 수 없습니다.'
    }

    if (step === STEP.CONTRACT_SIGN && !(data && data.c2f)) {
        return '수요기업의 계약서 서명이 완료되지 않아 다음 단계로 이동할 수 없습니다.'
    }

    if (step === STEP.DEPOSIT && !(data && data.c2f)) {
        return '수요기업의 계약서 서명 완료 후 선금 납부 단계로 이동할 수 있습니다.'
    }

    if (step === STEP.DEV1 && !(data && data.d2f)) {
        return '선금 확인이 완료되지 않아 1단계 개발로 이동할 수 없습니다.'
    }

    if (step === STEP.DEV1_RECEIVE && !(data && data.develop1)) {
        return '1단계 개발 보고서 제출 후 1단계 보고서 수신 단계로 이동할 수 있습니다.'
    }

    if (step === STEP.DEV1_APPROVE && !(data && data.r1f)) {
        return '수요기업의 1단계 보고서 승인이 완료되지 않아 다음 단계로 이동할 수 없습니다.'
    }

    if (step === STEP.MIDDLE && !(data && data.r1f)) {
        return '1단계 보고서 승인 후 중도금 납부 단계로 이동할 수 있습니다.'
    }

    if (step === STEP.DEV2 && !(data && data.d4f)) {
        return '중도금 확인이 완료되지 않아 2단계 개발로 이동할 수 없습니다.'
    }

    if (step === STEP.DEV2_RECEIVE && !(data && data.develop2)) {
        return '2단계 개발 보고서 제출 후 2단계 보고서 수신 단계로 이동할 수 있습니다.'
    }

    if (step === STEP.DEV2_APPROVE && !(data && data.r2f)) {
        return '수요기업의 2단계 보고서 승인이 완료되지 않아 다음 단계로 이동할 수 없습니다.'
    }

    if (step === STEP.FINAL_REPORT && !(data && data.r2f)) {
        return '2단계 보고서 승인 후 3단계 개발로 이동할 수 있습니다.'
    }

    if (step === STEP.FINAL_REPORT_RECEIVE && !(data && data.develop3)) {
        return '3단계 개발 보고서 제출 후 3단계 보고서 수신 단계로 이동할 수 있습니다.'
    }

    if (step === STEP.FINAL_REPORT_APPROVE && !(data && data.r3f)) {
        return '수요기업의 3단계 보고서 승인이 완료되지 않아 다음 단계로 이동할 수 없습니다.'
    }

    if (step === STEP.FINAL_PAY && !(data && data.r3f)) {
        return '3단계 보고서 승인 후 잔금 납부 단계로 이동할 수 있습니다.'
    }

    if (step === STEP.DONE && !(data && data.e1)) {
        return '잔금 확인이 완료되지 않아 프로젝트 완료로 이동할 수 없습니다.'
    }

    return '이전 단계 완료 후 다음 단계로 이동할 수 있습니다.'
}

// 관리자 단계 하향 경고 문구
export function getAdminStepDownWarningMessage(step) {
    if (
        step === STEP.ESTIMATE_RECEIVE ||
        step === STEP.ESTIMATE_APPROVE ||
        step === STEP.CONTRACT_WRITE ||
        step === STEP.CONTRACT_RECEIVE ||
        step === STEP.CONTRACT_SIGN ||
        step === STEP.DEPOSIT ||
        step === STEP.DEV1 ||
        step === STEP.DEV1_RECEIVE ||
        step === STEP.DEV1_APPROVE ||
        step === STEP.MIDDLE ||
        step === STEP.DEV2 ||
        step === STEP.DEV2_RECEIVE ||
        step === STEP.DEV2_APPROVE ||
        step === STEP.FINAL_REPORT ||
        step === STEP.FINAL_REPORT_RECEIVE ||
        step === STEP.FINAL_REPORT_APPROVE ||
        step === STEP.FINAL_PAY ||
        step === STEP.DONE
    ) {
        return '단계를 낮추면 수요기업의 재승인 또는 재입력이 필요할 수 있습니다. 변경하시겠습니까?'
    }

    return '이전 단계로 변경하시겠습니까?'
}

// nums 탭별 최소 단계
export function getMinStepByNums(tabNum) {
    if (tabNum === 1) return STEP.ESTIMATE_WRITE
    if (tabNum === 2) return STEP.CONTRACT_WRITE
    if (tabNum === 3) return STEP.CONTRACT_WRITE
    if (tabNum === 4) return STEP.DEPOSIT
    if (tabNum === 5) return STEP.DEV1
    if (tabNum === 6) return STEP.DEV2
    if (tabNum === 7) return STEP.FINAL_REPORT
    return STEP.TEMP
}

// 현재 단계에서 해당 탭 실데이터 노출 가능 여부
export function canViewRealByNums(step, tabNum) {
    var minStep = getMinStepByNums(tabNum)
    return getStepOrder(step) >= getStepOrder(minStep)
}
